import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { singleDayGrafModalActions } from '../../../redux/profiles/patientHealthboard/single-day-graf-modal';
import {
  loggedUserSelector,
  targetUserSelector,
} from '../../../redux/context/selectors';
import {
  combinedPendingDataModalRequest,
  selectBaseDateSingleDayGrafModal,
  selectOpenedSingleDayGrafModal,
  selectTypeSingleDayGrafModal,
} from '../../../redux/profiles/patientHealthboard/selectors';

const mapStateToProps = state => ({
  openedSingleDayGrafModal: selectOpenedSingleDayGrafModal(state),
  type: selectTypeSingleDayGrafModal(state),
  baseDate: selectBaseDateSingleDayGrafModal(state),
  combinedPendingDataModalRequest: combinedPendingDataModalRequest(state),
  profile: loggedUserSelector(state),
  profileTargetUser: targetUserSelector(state),
});

const mapDispatchToProps = {
  close: singleDayGrafModalActions.close,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/SingleDayGrafModal/enhance.js